import api from "../services/authService";

/**
 * Home flow — the personal work surface (backend: dms_backend
 * /api/home/flow/; design contract: whg-salesforce
 * docs/work-items-umbrella.md, Home-as-My-Court).
 *
 * One GET answers the two questions Home exists to ask: what's in my
 * court, and what am I waiting on from others. Four streams arrive
 * pre-merged and ranked worst-first — work items (Salesforce doorway),
 * doc reviews, signatures, tasks — in one row shape:
 *
 * `{ work_items_enabled, salesforce_ok, in_my_court: [row],
 *    waiting_on_others: [row] }`
 *
 * Row: `{ kind: work_item|doc_review|signature|task, key, id, title,
 *   matter_id, matter_name, counterparty, age_days, due_on, staleness,
 *   stale_label, category?, document?, work_item?, review?, signature?,
 *   task? }`.
 * `salesforce_ok: false` means the work-item stream is missing this
 * refresh — the local streams still answered.
 *
 * Pass `user` (id or email) to read a colleague's plate — same shape,
 * plus `viewing: {id, name, email, is_self}` (dms_backend #2063).
 * Unknown user → 404.
 */
export const getHomeFlow = (user) =>
  api.get(
    user
      ? `/home/flow/?user=${encodeURIComponent(user)}`
      : "/home/flow/"
  );

/**
 * Acknowledge a row on the *Finished this week* card: it leaves the
 * caller's card (nobody else's). Repeat calls are harmless.
 */
export const acknowledgeFinishedWork = (workItemId) =>
  api.post(
    `/home/finished/${encodeURIComponent(workItemId)}/acknowledge/`
  );
